/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UserDelegationTenant {
    getFixupPrototypeFunction() { return UserDelegationTenant.fixupPrototype; }

    static newInstance(model: Partial<UserDelegationTenant>): UserDelegationTenant {
        let obj = Object.assign(new UserDelegationTenant(), model);
        UserDelegationTenant.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UserDelegationTenant>): UserDelegationTenant {
        if (!model) return null;
        return UserDelegationTenant.newInstance(<UserDelegationTenant> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UserDelegationTenant) {
        if (!obj) return;

        models.UserDelegationTenant.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UserDelegationTenant): boolean {
        Object.setPrototypeOf(obj, UserDelegationTenant.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.roles) {
            for (let val of this.roles) {
                models.UserDelegationRole.fixupPrototype(val);
            }
        }
    }

    /**
     * Tenant id
     */
    tenant_id: string;

    /**
     * Tenant name
     */
    tenant_name: string;

    /**
     * Delegation roles
     */
    roles: Array<models.UserDelegationRole>;

}
